import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { StyledCheckbox } from "./checkbox.scss";
import { CheckIcon } from "./check-icon";
import classnames from "classnames";
const Checkbox = ({ checked, color, hovered })=>/*#__PURE__*/ _jsx(StyledCheckbox, {
        hovered: hovered,
        color: color,
        className: classnames("checkbox", {
            checked
        }),
        children: /*#__PURE__*/ _jsx("span", {
            className: "checkmark",
            children: /*#__PURE__*/ _jsx(CheckIcon, {
                color: color
            })
        })
    });
export default Checkbox;
